<template>
  <div class="PublisherPluginStatus">
    <div class="PublisherPluginStatus__chart">
      <canvas id="plugin-status"></canvas>
      <div class="PublisherPluginStatus__total-label">{{ total }}</div>
    </div>
    <div class="PublisherPluginStatus__legend">
      <div
        v-for="legendRow in legendsData"
        :key="legendRow.slug"
        class="PublisherPluginStatus__legend-row"
      >
        <div
          class="PublisherPluginStatus__legend-color"
          :style="{ background: legendRow.color }"
        ></div>
        <div>
          <div class="PublisherPluginStatus__legend-label">
            {{ legendRow.label }}
          </div>
          <div class="PublisherPluginStatus__legend-value">
            {{ legendRow.value }} plugins
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

// Status configuration mapping API status types to display labels and colors
const statusConfig = {
  'published': {
    label: 'Published',
    color: 'rgb(87, 76, 250)',
  },
  'in-review': {
    label: 'In Review',
    color: 'rgba(87, 76, 250, 0.5)',
  },
  'draft': {
    label: 'Draft',
    color: 'rgba(87, 76, 250, 0.2)',
  },
  'suspended': {
    label: 'Suspended',
    color: 'rgba(255, 76, 76, 0.5)',
  },
}

// Legacy support - map old slugs to API status types
const legacyStatusMap = {
  'ready-for-sale': 'published',
  'in-review': 'in-review',
  'draft': 'draft',
  'suspended': 'suspended',
}

export default {
  name: 'PublisherPluginStatus',
  props: {
    chartData: Array,
  },
  data() {
    return {
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [],
            borderColor: '#1C1B2E',
            borderWidth: 4,
            borderAlign: 'inner',
            spacing: 10,
            hoverOffset: 4,
          },
        ],
      },
      options: {
        cutoutPercentage: 80,
        legend: false,
      },
      legendsData: [],
      total: 0,
    }
  },
  async mounted() {
    // Build legends and chart data from API status types
    this.legendsData = this.chartData.map((row) => {
      // Handle both API status types and legacy slugs
      const status = legacyStatusMap[row.slug] || row.slug || row.status
      const config = statusConfig[status] || {
        label: status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' '),
        color: 'rgba(87, 76, 250, 0.3)',
      }
      
      return {
        slug: status,
        label: config.label,
        color: config.color,
        value: row.count || row.value || 0,
      }
    })
    
    // Update chart data
    this.data.labels = this.legendsData.map((legend) => legend.label)
    this.data.datasets[0].data = this.legendsData.map((legend) => legend.value)
    this.data.datasets[0].backgroundColor = this.legendsData.map((legend) => legend.color)
    
    this.total = this.legendsData.reduce((acc, cur) => acc + cur.value, 0)
    
    const ctx = document.getElementById('plugin-status')
    new Chart(ctx, {
      type: 'doughnut',
      data: this.data,
      options: this.options,
    })
  },
}
</script>

<style lang="scss">
$style: PublisherPluginStatus;
.#{$style} {
  display: flex;
  flex-direction: row;
  align-items: center;
  &__chart {
    position: relative;
  }
  &__total-label {
    position: absolute;
    font-size: 28px;
    font-weight: bold;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &__legend-row {
    display: flex;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 15px;
  }
  &__legend-color {
    width: 30px;
    height: 4px;
    border-radius: 10px;
    margin-top: 9px;
    margin-right: 15px;
  }
  &__legend-label {
    color: #585b6a;
    margin-bottom: 4px;
    font-weight: 500;
  }
  &__legend-value {
    color: white;
    font-weight: 600;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    &__chart {
      margin-bottom: 12px;
    }
    &__legend-row {
      margin-bottom: 4px;
    }
  }
}
.w-full {
  width: 100%;
}
</style>
